import { cn } from '@/shared/lib';

export interface SpinnerProps {
  className?: string;
}

/** Индикатор ожидания для кнопок в состоянии loading (цвет — currentColor). */
export function Spinner({ className }: SpinnerProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-block size-12 shrink-0 animate-spin rounded-pill border-2 border-current border-r-transparent',
        className,
      )}
    />
  );
}
